export default __webpack_public_path__ + "static/media/icon-view.fc0ac7e6.svg";